import { SET_COUPONDETAILLIST } from '../actions';

const coupondetails = (state = [], action) => {
  switch (action.type) {
	case SET_COUPONDETAILLIST:
      return [...action.value];  
    default: return state;
  }
}

export default coupondetails;
